import injectTapEventPlugin from 'react-tap-event-plugin'
import Routes from 'routes'
import { hotjar } from 'utils'
import 'style.scss'

const { hotjarSiteIds, hotjarBumpVersions } = config
hotjar((__RELEASE__) ? hotjarSiteIds.production : hotjarSiteIds.development, (__RELEASE__) ? hotjarBumpVersions.production : hotjarBumpVersions.development)

injectTapEventPlugin()

ReactDOM.render(<Routes />, document.getElementById('app'));



// WEBPACK FOOTER //
// ./app/index.js